import React from 'react';
import { Button } from 'antd';
import { InboxOutlined, CheckCircleOutlined } from '@ant-design/icons';

export function OiEmptyState({
  title,
  body,
  actionLabel,
  onAction,
  variant = 'default',
}: {
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
  variant?: 'default' | 'positive';
}) {
  const icon =
    variant === 'positive' ? (
      <CheckCircleOutlined className="oi-empty-state__icon" style={{ color: 'var(--oi-emerald)' }} />
    ) : (
      <InboxOutlined className="oi-empty-state__icon" />
    );

  return (
    <div className="oi-empty-state">
      {icon}
      <div className="oi-empty-state__title">{title}</div>
      <div className="oi-empty-state__body">{body}</div>
      {actionLabel && onAction ? (
        <Button type="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
}
